<article class="content">
  <p *ngFor="let errorMessage of errorMessages" class="technical-error">
    {{ errorMessage }} Prosimy o przesłanie numeru błędu lub zrzutu ekranu na adres email {{ email | async }}
  </p>
</article>
